module.exports = __webpack_public_path__ + "static/media/checkmark-white.ee5d8657.svg";